import { Star, Truck } from "lucide-react";
import { PHONE, PHONE_TEL, PROMO } from "@/lib/site";

export default function FlyerMaricopa() {
  return (
    <div className="min-h-screen bg-slate-300 py-10 print:bg-white print:py-0">
      <div className="mx-auto flex justify-center pb-6 print:hidden">
        <button
          data-testid="flyer-print-button"
          onClick={() => window.print()}
          className="rounded-full bg-brand-navy px-8 py-3 font-display text-sm font-extrabold uppercase tracking-widest text-white shadow-lg transition-transform hover:scale-105"
        >
          Print / Save as PDF
        </button>
      </div>

      <div data-testid="flyer-page" className="mx-auto bg-white shadow-2xl print:shadow-none" style={{ width: "8.5in", minHeight: "11in" }}>
        <div className="flex items-center justify-between bg-brand-navy px-10 py-6 text-white">
          <div className="flex items-center gap-3">
            <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-fall-amber">
              <Star className="h-7 w-7 fill-brand-navy text-brand-navy" />
            </span>
            <div>
              <p className="font-display text-2xl font-extrabold tracking-tight">OXFORD CLEANERS</p>
              <p className="text-[10px] font-bold uppercase tracking-[0.3em] text-amber-300">Veteran &amp; Family-Owned</p>
            </div>
          </div>
          <p className="text-right text-xs font-semibold leading-relaxed text-slate-300">
            Dry Cleaning · Wash &amp; Fold
            <br />
            Comforters · Alterations
          </p>
        </div>

        <div className="px-10 pt-8 text-center">
          <p className="inline-block rounded-full bg-fall-orange px-5 py-1.5 text-xs font-extrabold uppercase tracking-[0.25em] text-white">
            New Route
          </p>
          <h1 className="mt-4 font-display text-4xl font-extrabold leading-tight tracking-tight text-brand-navy">
            Maricopa — free pickup &amp; delivery <span className="text-fall-orange">is here.</span>
          </h1>
          <p className="mt-2 text-sm font-semibold text-slate-500">
            Routes every Tuesday &amp; Friday · Serving 85138 · 85139 · 85238 · 85239
          </p>
        </div>

        <div className="px-10 pt-6">
          <img src="/images/fall_special.png" alt="Freshly cleaned fall comforters" className="h-44 w-full rounded-2xl object-cover" />
        </div>

        <div className="px-10 pt-6">
          <div className={`rounded-2xl border-2 p-6 ${PROMO.key === "winter" ? "border-sky-300 bg-sky-50" : "border-fall-amber bg-fall-bg"}`}>
            <p className="text-center text-xs font-extrabold uppercase tracking-[0.3em] text-fall-orange">
              {PROMO.name} · ends {PROMO.endsLabel}
            </p>
            <div className="mt-4 grid grid-cols-2 gap-4 text-center">
              <div className="rounded-xl bg-white p-4 shadow-sm">
                <p className="text-[10px] font-bold uppercase tracking-widest text-slate-500">2+ comforters</p>
                <p className="font-display text-4xl font-extrabold text-brand-navy">
                  $19.99<span className="text-sm font-bold text-slate-500"> each</span>
                </p>
                <p className="text-[10px] font-bold uppercase tracking-widest text-fall-orange">Best deal</p>
              </div>
              <div className="rounded-xl bg-white p-4 shadow-sm">
                <p className="text-[10px] font-bold uppercase tracking-widest text-slate-500">Just 1 comforter</p>
                <p className="font-display text-4xl font-extrabold text-brand-navy">$25</p>
                <p className="text-[10px] font-bold uppercase tracking-widest text-slate-400">per piece</p>
              </div>
            </div>
            <p className="mt-4 text-center text-xs font-semibold leading-relaxed text-slate-600">
              When did you last wash your comforter? 1.5 million dust mites can live in one unwashed
              comforter — experts recommend a professional clean every 2–3 months.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-3 gap-3 px-10 pt-6 text-center">
          {["Book online or call", "We pick up at your door", "Back fresh in ~48 hrs"].map((s, i) => (
            <div key={s} className="rounded-xl bg-slate-50 p-3">
              <p className="font-display text-lg font-extrabold text-fall-orange">0{i + 1}</p>
              <p className="text-xs font-semibold text-slate-600">{s}</p>
            </div>
          ))}
        </div>

        <div className="mt-8 flex items-center gap-3 bg-fall-orange px-10 py-5 text-white">
          <Truck className="h-8 w-8 shrink-0" />
          <div>
            <p className="font-display text-lg font-extrabold uppercase tracking-wide">Free pickup &amp; delivery</p>
            <p className="text-xs font-semibold text-amber-100">
              Maricopa · Chandler · Gilbert · Tempe · Ahwatukee · Sun Lakes
            </p>
          </div>
        </div>

        <div className="flex items-center justify-between bg-brand-navy px-10 py-6 text-white">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-amber-300">Call or scan to book</p>
            <a data-testid="flyer-phone-link" href={PHONE_TEL} className="font-display text-3xl font-extrabold tracking-tight">
              {PHONE}
            </a>
            <p className="text-sm font-semibold text-slate-300">oxford-cleaners.com</p>
          </div>
          <img data-testid="flyer-qr" src="/images/qr_oxford.png" alt="Scan to visit oxford-cleaners.com" className="h-24 w-24 rounded-xl bg-white p-1.5" />
        </div>
      </div>
    </div>
  );
}
